import type { ReactNode } from "react";
import { X } from "lucide-react";
import { useIntl } from "react-intl";

import { Button, Card, CardContent } from "@runcheetah/ui";

export function BillingModalShell({
  title,
  description,
  onClose,
  children,
  footer,
  widthClassName,
}: {
  title: string;
  description?: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  widthClassName?: string;
}) {
  const intl = useIntl();

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-background/75 p-4 backdrop-blur-sm">
      <Card
        className={`w-full border-border/70 bg-card/95 shadow-deep ${widthClassName ?? "max-w-3xl"}`}
      >
        <CardContent className="space-y-6 p-6 sm:p-8">
          <div className="flex items-start justify-between gap-4">
            <div className="space-y-2">
              <h2 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h2>
              {description ? (
                <p className="max-w-2xl text-sm leading-6 text-muted-foreground">{description}</p>
              ) : null}
            </div>
            <Button type="button" size="icon" variant="ghost" onClick={onClose}>
              <X className="size-5" aria-hidden="true" />
              <span className="sr-only">
                {intl.formatMessage({ id: "common.close", defaultMessage: "Close" })}
              </span>
            </Button>
          </div>
          {children}
          {footer ? (
            <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">{footer}</div>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}
